import { BaseService, PaginatedResult } from "./base.service";
import {
  HealthMemoryDto,
  CreateHealthMemoryDto,
  UpdateHealthMemoryDto,
  HealthMemoryResponseDto,
  HealthMemoryQueryParams,
} from "@/types/health-memory";

export class HealthMemoryService extends BaseService {
  private memberId: string;

  constructor(memberId: string) {
    super(`/members/${memberId}/health-memory`);
    this.memberId = memberId;
  }

  async getHealthMemories(
    filter?: any
  ): Promise<PaginatedResult<HealthMemoryResponseDto>> {
    return await this.post<PaginatedResult<HealthMemoryResponseDto>>(
      "/getAll",
      filter || {}
    );
  }

  async getHealthMemory(id: string): Promise<HealthMemoryResponseDto> {
    return await this.get<HealthMemoryResponseDto>(`/${id}`);
  }

  async createHealthMemory(
    memory: CreateHealthMemoryDto
  ): Promise<HealthMemoryResponseDto> {
    return await this.post<HealthMemoryResponseDto>("", memory);
  }

  async updateHealthMemory(
    id: string,
    memory: UpdateHealthMemoryDto
  ): Promise<HealthMemoryResponseDto> {
    return await this.put<HealthMemoryResponseDto>(`/${id}`, memory);
  }

  async deleteHealthMemory(id: string): Promise<void> {
    await this.delete(`/${id}`);
  }

  async uploadVoiceNote(
    id: string,
    blob: Blob
  ): Promise<HealthMemoryResponseDto> {
    const formData = new FormData();
    formData.append("file", blob, "voice-note.wav");
    return await this.post<HealthMemoryResponseDto>(
      `/${id}/voice-note`,
      formData,
      { headers: { "Content-Type": undefined } }
    );
  }

  async getVoiceNoteUrl(id: string): Promise<{ url: string }> {
    return await this.get<{ url: string }>(`/${id}/voice-note/url`);
  }

  async patchTranscript(
    id: string,
    transcript: string
  ): Promise<HealthMemoryResponseDto> {
    return await this.patch<HealthMemoryResponseDto>(`/${id}/transcript`, {
      transcript,
    });
  }

  async retryTranscript(id: string): Promise<HealthMemoryResponseDto> {
    return await this.post<HealthMemoryResponseDto>(
      `/${id}/transcript/retry`,
      {}
    );
  }
}
